import { render } from "./BenefitsSection.vue?vue&type=template&id=62305762&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"

import "./BenefitsSection.vue?vue&type=style&index=0&id=62305762&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62305762"]])

export default __exports__